import request, { gql } from "graphql-request";

export const GETDASHBOARDDATA = gql`
 query FilterAllData(
  $userId: ID
  $status: String
  $date: Date
  $startDate: Date
  $endDate: Date
  $month: Int
  $monthName: String
  $isTeamBased: Boolean
) {
  filterAllData(
    userId: $userId
    status: $status
    date: $date
    startDate: $startDate
    endDate: $endDate
    month: $month
    monthName: $monthName
    isTeamBased: $isTeamBased
  ) {
    success
    message
    downloadUrl
    downloadPdfUrl
 
    summaryStats {
      totalEnteredByHr
      totalSelected
      totalRejected
      totalHold
    }
 
    statusCounts {
      status
      count
    }
 
    monthlyOnboardedCounts {
      month
      count
    }
  }
}
 `;

export const GETACTIVELOGDATA = gql`
  query GetAllLogs($search: String, $page: Int!, $pageSize: Int!) {
    allLogs(search: $search, page: $page, pageSize: $pageSize) {
      success
      error
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      dataList {
        id
        userId
        roleCode
        action
        entityType
        entityId
        oldValues
        newValues
        ipAddress
        userAgent
        createdAt
        updatedAt
        user {
          id
          userName
          email
        }
      }
    }
  }
`;

export const ExportCSV = gql`
  mutation ExportAnalytics {
    exportAnalyticsCsv {
      fileUrl
    }
  }
`;

export const ExportPDF = gql`
  mutation generatePdf($isTeamBased: Boolean) {
  generatePdf(isTeamBased: $isTeamBased) {
    success
    message
    filePath
  }
}
`;
